import { useEffect, useRef } from 'react';

/**
 * Hook which helps get the previous value of a prop. Very soon this might come to be a part of the React Hooks Out of the box
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 * @param value
 * @param defaultValue
 */
export const usePrevious = <T>(value: T, defaultValue?: T): T => {
    const ref = useRef<T>(defaultValue);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
